import queryString from 'query-string';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import CommonConstants from 'sg-common-constants';
import { SgSessionStorageService } from 'saga-modules';

/**
 * Provides the selected product (car, motorhome or home) from the params passed by query string. The default value is car.
 */

let productValue; // cached value
const MOTOR_PATH_NAME = '/motorhome-insurance/';
const CAR_PRODUCT = 'car';
const MOTORHOME_PRODUCT = 'mh';
const HOME_PRODUCT = 'home';
const QUICKQUOTE_PRODUCT = 'qq';
const SMI_PRODUCT = 'pmi';
const TRAVEL_PRODUCT = 'spt';
const TRAVEL_NAME = 'Travel';
const CAR_NAME = 'Car';
const MOTORHOME_NAME = 'Motorhome';
const PROPERTY_NAME = 'Property';
const HEALTH_NAME = 'health';
const HOME_NAME = 'Home';
const SMI_NAME = 'Health';
const path = window.location.href;
const MOTOR_PRODUCT_CATEGORY = 'motor products';
const HOME_PRODUCT_CATEGORY = 'home products';
const SMI_PRODUCT_CATEGORY = 'health products';
const SPT_PRODUCT_CATEGORY = 'travel products';
const CAR_INSURANCE_NAME = 'car insurance';
const MOTORHOME_INSURANCE_NAME = 'motorhome insurance';
const HOME_INSURANCE_NAME = 'home insurance';
const HEALTH_INSURANCE_NAME = 'health insurance (pmi)';
const TRAVEL_INSURANCE_NAME = 'travel insurance';
/**
 * Reads the product from the URL.
 * @returns the product
 */
export default {

    getProduct: function getProduct() {
        if (productValue !== undefined) { // if already defined, return the value
            return productValue;
        }
        // else, read it from the url
        let value;
        if (window.location.search) {
            value = queryString.parse(window.location.search).pdt;
        } else if (appConfig.isMotor) {
            if (path.indexOf(MOTOR_PATH_NAME) !== -1) {
                value = MOTORHOME_PRODUCT;
            } else {
                value = CAR_PRODUCT;
            }
        } else if (appConfig.isHome) {
            value = HOME_PRODUCT;
        } else if (appConfig.isQuickQuote) {
            value = QUICKQUOTE_PRODUCT;
        } else if (appConfig.isSmi) {
            value = SMI_PRODUCT;
        } else if (appConfig.isTravel) {
            value = TRAVEL_PRODUCT;
        } else {
            const searchPart = window.location.hash.split('?');
            let searchParams = {};
            if (searchPart.length === 2) {
                searchParams = queryString.parse(searchPart[1]);
            }
            value = searchParams.pdt;
        }

        if (value) {
            productValue = value.toLowerCase(); // cache the value
        }
        return productValue;
    },

    isMotorHome: function isMotorHome() {
        return this.getProduct() === MOTORHOME_PRODUCT;
    },

    isHome: function () {
        return this.getProduct() === HOME_PRODUCT || (this.getProduct() === QUICKQUOTE_PRODUCT && window.location.hash.includes(HOME_PRODUCT));
    },

    isCar: function () {
        return this.getProduct() === CAR_PRODUCT || (this.getProduct() === QUICKQUOTE_PRODUCT && window.location.hash.includes(CAR_PRODUCT));
    },

    isQuickQuoteHome: function () {
        return SgSessionStorageService.getItem(SgSessionStorageService.KEY.IS_QQ_HOME) === 'true';
    },

    isQuickQuoteMotor: function () {
        return SgSessionStorageService.getItem(SgSessionStorageService.KEY.IS_QQ_MOTOR) === 'true';
    },

    isSmi: function () {
        return this.getProduct() === SMI_PRODUCT;
    },

    isTravel: function () {
        return this.getProduct() === TRAVEL_PRODUCT;
    },

    coverableName: function () {
        let coverableName;
        if (this.isCar()) {
            coverableName = CAR_NAME;
        } else if (this.isMotorHome()) {
            coverableName = MOTORHOME_NAME;
        } else if (this.isHome()) {
            coverableName = PROPERTY_NAME;
        } else if (this.isSmi()) {
            coverableName = HEALTH_NAME;
        }
        return coverableName;
    },

    productName: function () {
        let productName;
        if (this.isCar()) {
            productName = CAR_NAME;
        } else if (this.isMotorHome()) {
            productName = MOTORHOME_NAME;
        } else if (this.isHome()) {
            productName = HOME_NAME;
        } else if (this.isSmi()) {
            productName = SMI_NAME;
        } else if (this.isTravel()) {
            productName = TRAVEL_NAME;
        }
        return productName;
    },

    getProductCategory: function () {
        let productCategory;
        if (this.isCar() || this.isMotorHome()) {
            productCategory = MOTOR_PRODUCT_CATEGORY;
        } else if (this.isHome()) {
            productCategory = HOME_PRODUCT_CATEGORY;
        } else if (this.isSmi()) {
            productCategory = SMI_PRODUCT_CATEGORY;
        } else if (this.isTravel()) {
            productCategory = SPT_PRODUCT_CATEGORY;
        }
        return productCategory;
    },

    getInsuranceProductName: function (productCode) {
        let productName;
        if (productCode === CommonConstants.MOTOR_PRODUCT_CODE || this.isCar()) {
            productName = CAR_INSURANCE_NAME;
        } else if (productCode === CommonConstants.MOTORHOME_PRODUCT_CODE || this.isMotorHome()) {
            productName = MOTORHOME_INSURANCE_NAME;
        } else if (productCode === CommonConstants.HOME_PRODUCT_CODE || this.isHome()) {
            productName = HOME_INSURANCE_NAME;
        } else if (productCode === CommonConstants.PRIVATE_MEDICAL_INSURANCE_CODE || this.isSmi()) {
            productName = HEALTH_INSURANCE_NAME;
        } else if (productCode === CommonConstants.TRAVEL_PRODUCT_CODE || this.isTravel()) {
            productName = TRAVEL_INSURANCE_NAME;
        }
        return productName;
    },

    getProductCode: function () {
        if (appConfig.isHome) {
            return CommonConstants.HOME_PRODUCT_CODE;
        }
        if (appConfig.isMotor) {
            return CommonConstants.MOTOR_PRODUCT_CODE;
        }
        if (appConfig.isSmi) {
            return CommonConstants.PRIVATE_MEDICAL_INSURANCE_CODE;
        }
        if (appConfig.isTravel) {
            return CommonConstants.TRAVEL_PRODUCT_CODE;
        }
        return '';
    }
};
